<template>
  <div class="search-box">
    <el-autocomplete
      v-if="currentTab.fetchSuggestions"
      v-model="localKeywords"
      :fetch-suggestions="querySearchAsync"
      :placeholder="currentTab.placeholder"
      clearable
      @select="handleSelect"
      @keyup.enter.native="handleSearch"
    >
      <template slot="append">
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">
          搜索
        </el-button>
      </template>
    </el-autocomplete>
    <el-input
      v-else
      v-model="localKeywords"
      :placeholder="currentTab.placeholder"
      clearable
      @keyup.enter.native="handleSearch"
      @clear="clearHandle"
    >
      <template slot="append">
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">
          搜索
        </el-button>
      </template>
    </el-input>
    <div v-if="showTab" class="flex row-center m-t-22">
      <tab-switch
        v-model="activeIndex"
        :tab-list="tabList"
        v-bind="tabSwitchAttrs"
        @changeTab="handleChangeTab"
      />
    </div>
  </div>
</template>

<script>
// 组件
import TabSwitch from '@/components/common/TabSwitch'
// 接口
import { getCompanyApi } from '@/api/analysis'

import { mapState } from 'vuex'

export default {
  name: 'SearchBox',

  components: { TabSwitch },

  model: {
    prop: 'keywords',
    event: 'change'
  },

  props: {
    tabSwitchAttrs: {
      type: Object,
      default: () => {
        return {
          fontSize: '16px'
        }
      }
    },

    tabIndex: {
      type: Number,
      default: 0,
      validator: (value) => [0, 1, 2].indexOf(value) > -1
    },

    tabName: {
      type: String,
      default: 'notice',
      validator: (value) =>
        ['notice', 'competitor', 'purchaser'].indexOf(value) > -1
    },

    keywords: {
      type: String,
      default: ''
    },

    showTab: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      activeIndex: 0,
      localKeywords: ''
    }
  },

  computed: {
    ...mapState('user', ['isLogin', 'isPortraitBtnShow']),

    currentTab() {
      return this.tabList[this.activeIndex] || {}
    },

    tabList() {
      // if (!this.isLogin) {
      //   return [
      //     {
      //       label: '找商机',
      //       placeholder: '请输入你要查询的信息',
      //       fetchSuggestions: '',
      //       name: 'notice',
      //       routeName: 'NetworkNotice'
      //     }
      //   ]
      // } else {
      //   if (!this.isPortraitBtnShow) {
      //     return [
      //       {
      //         label: '找商机',
      //         placeholder: '请输入你要查询的信息',
      //         fetchSuggestions: '',
      //         name: 'notice',
      //         routeName: 'NetworkNotice'
      //       }
      //     ]
      //   } else {
      //     return [
      //       {
      //         label: '找商机',
      //         placeholder: '请输入你要查询的信息',
      //         fetchSuggestions: '',
      //         name: 'notice',
      //         routeName: 'NetworkNotice'
      //       },
      //       {
      //         label: '查竞争对手',
      //         placeholder: '请输入企业名称',
      //         fetchSuggestions: getCompanyApi,
      //         name: 'competitor',
      //         routeName: 'CompetitorAnalysisList'
      //       },
      //       {
      //         label: '查采购单位',
      //         placeholder: '请输入采购单位名称',
      //         fetchSuggestions: getCompanyApi,
      //         name: 'purchaser',
      //         routeName: 'PurchaserAnalysisList'
      //       }
      //     ]
      //   }
      // }
      return [
        {
          label: '找商机',
          placeholder:
            '请输入您要查询的项目名称、招标信息关键词、或项目发布单位名称',
          fetchSuggestions: '',
          name: 'notice',
          routeName: 'NetworkNotice'
        },
        {
          label: '查竞争对手',
          placeholder:
            '输入您的竞争对手（企业）名称后进行“搜索”，点击“开始分析”即可查看竞争对手的最近参与项目、历史中标业绩、重点合作客户、主要市场区域',
          fetchSuggestions: getCompanyApi,
          name: 'competitor',
          routeName: 'CompetitorAnalysisList'
        },
        {
          label: '查采购单位',
          placeholder:
            '输入采购单位名称并搜索，点击“开始分析”即可获取采购单位历史项目联系人、最新招标信息、重点合作供应商，分析历史招标规模，采购偏好',
          fetchSuggestions: getCompanyApi,
          name: 'purchaser',
          routeName: 'PurchaserAnalysisList'
        }
      ]
    }
  },

  watch: {
    tabIndex: {
      handler(val) {
        this.activeIndex = val
      },
      immediate: true
    },

    tabName: {
      handler(val) {
        this.activeIndex = this.tabList.findIndex((item) => item.name === val)
      },
      immediate: true
    },

    keywords: {
      handler(val) {
        this.localKeywords = val
      },
      immediate: true
    },

    localKeywords: {
      handler(val) {
        this.$emit('change', val)
      }
    }
  },

  methods: {
    querySearchAsync(queryString, cb) {
      if (!this.currentTab.fetchSuggestions) return

      const restaurants = []
      this.currentTab
        .fetchSuggestions({ keywords: queryString })
        .then((res) => {
          if (res.data.records && res.data.records.length) {
            res.data.records.map((item) => {
              item.value = item.companyName
              restaurants.push(item)
            })
          }
        })
        .catch((err) => {
          if (err?.data?.message) this.$message.error(err.data.message)
        })
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(restaurants)
      }, 500 * Math.random())
    },

    handleSelect() {
      this.$emit('select', this.localKeywords)
    },
    clearHandle() {
      // this.handleSearch()
    },
    /**
     * 查询采购单位/竞争对手列表
     */
    getCompanyList() {
      this.competitorLoading = true
      getCompanyApi(this.filterForm)
        .then((res) => {
          this.competitorLoading = false
          this.companyList = res.data.records
          this.total = res.data.total
        })
        .catch((err) => {
          if (err?.data?.message) this.$message.error(err.data.message)
          this.competitorLoading = false
        })
    },

    /**
     * 点击搜索
     */
    handleSearch() {
      this.$emit('search', this.localKeywords, this.currentTab.routeName)
    },

    handleChangeTab() {
      this.$emit('changeTab', this.currentTab.name, this.currentTab.routeName)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  flex-direction: column;

  ::v-deep {
    .el-input-group {
      width: 100%;
    }
    .el-input--small .el-input__inner {
      height: 48px;
      line-height: 48px;
      border: 1px solid $primary-color;
      font-size: 16px;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      background: $primary-color;
      color: $white-color;
      border: 1px solid $primary-color;
      font-size: 16px;
    }
  }
}
</style>
